import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotBridgeClearancesApiMeta } from "../apiMeta";
import {
  type BridgeClearancesInput,
  bridgeClearancesInputSchema,
} from "./shared/bridgeClearances.input";
import {
  type BridgeClearance,
  bridgeClearanceSchema,
} from "./shared/bridgeClearances.output";

/**
 * Metadata for the fetchBridgeClearances endpoint
 */
export const bridgeClearancesMeta = {
  functionName: "fetchBridgeClearances",
  endpoint: "/getClearancesAsJson",
  inputSchema: bridgeClearancesInputSchema,
  outputSchema: bridgeClearanceSchema.array(),
  sampleParams: {},
  endpointDescription:
    "List vertical clearance data for all Washington State bridges.",
} satisfies EndpointMeta<BridgeClearancesInput, BridgeClearance[]>;

const { fetch, useHook } = createFetchAndHook<
  BridgeClearancesInput,
  BridgeClearance[]
>({
  api: wsdotBridgeClearancesApiMeta,
  endpoint: bridgeClearancesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/bridgeClearances.endpoints").bridgeClearancesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving vertical clearance data for all Washington State bridges
 */
export const fetchBridgeClearances: FetchFactory<
  BridgeClearancesInput,
  BridgeClearance[]
> = fetch;

/**
 * React Query hook for retrieving vertical clearance data for all Washington State bridges
 */
export const useBridgeClearances: HookFactory<
  BridgeClearancesInput,
  BridgeClearance[]
> = useHook;
